import Button from "components/CustomButtons/Button.js";
import MaterialSymbol from "components/MaterialSymbol/MaterialSymbol";

export default function EditButton({ handleClick = () => { } }) {
    return (
        <Button
            justIcon
            round
            simple
            color="warning"
            className="edit"
            onClick={handleClick}
        >
            <MaterialSymbol>edit</MaterialSymbol>
        </Button>
    )
}
